import { DrawingNationalSuperCupPairDto } from "./drawing-national-super-cup-pair.dto";

export class DrawingNationalSuperCupRequest {
    matchDay: number;
    pairs: DrawingNationalSuperCupPairDto[];
}